import type {
    GetAllOldPresidentsResponseType
} from "./type";
import {
    request
} from "../request";

const getAllOldPresidents = async (): Promise<GetAllOldPresidentsResponseType> => {
    return await request<GetAllOldPresidentsResponseType>("/content/getAllOldPresidents", {
        method: "GET"
    });
};
export default getAllOldPresidents;
